import { SelectBox, Switch, TextBox } from 'devextreme-react';
// import { Button } from 'devextreme-react/button';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import api from '../../../services/api-configuration-v3';
import useFormatMessage from '../../../utils/useFormatMessage';



const BayiFormPopup = ({ visible, onHiding, formData: initialData, setFormData: parentSetFormData, fetchData, type }) => {

    const { t } = useFormatMessage();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const REQUIRED_FIELDS = {
        location: t('location'),
        code: t('code'),  // Bayi Kodu zorunlu
        company_title: t('company_title'),
        group_company_title: t('group_company_title'),
        brand_id: t('brand_id'),
        group_region_id: t('group_region_id'),
        standard_address_id: t('standard_address_id'),
        excel_data: t('excel_data'),
    };
    const [localFormData, setLocalFormData] = useState({
        is_active: true
    });
    const [adress, setAdress] = useState([]);
    const [brand, setBrand] = useState([]);
    const [regions, setRegions] = useState([]);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (visible) {
            setLocalFormData(type === 'create' ? { is_active: true } : initialData);
            loadData();
        }
        // eslint-disable-next-line
    }, [visible, initialData, type]);

    const loadData = async () => {
        try {
            const [addressRes, brandRes, regionRes] = await Promise.all([
                api.post("/prmAddress/getAll"),
                api.post("/getAllBrands"),
                api.post("/shippingRegion/getAll")
            ]);

            setAdress(addressRes.data.data || []);
            setBrand(brandRes.data.data || []);
            setRegions(regionRes.data.data || []);
        } catch (error) {
            console.error("Error loading data:", error);
            toast.error(t("error_loading_data"));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        Object.entries(REQUIRED_FIELDS).forEach(([field, label]) => {
            // Eğer lokasyon "Özel Adres" ise, Bayi Kodu zorunlu değil
            if (field === 'code' && localFormData.location === 'Özel Adres') {
                return;
            }
            if (field === 'brand_id' && (localFormData.location === 'Özel Adres' || localFormData.location === 'Depo')) {
                return;
            }

            if (!localFormData[field] && localFormData[field] !== 0) {
                // newErrors[field] = `${label} alanı zorunludur`;
                newErrors[field] = t('field_required', { field: REQUIRED_FIELDS[field] });
                isValid = false;
            }
        });

        setErrors(newErrors);

        return isValid;
    };

    const handleInputChange = (name, inputType = "text") => (e) => {
        let value = e?.target ? e.target.value : e?.value ?? e;

        if (inputType === "number" && value !== "") {
            value = Number(value);
        }

        // Eğer lokasyon "Özel Adres" olarak değiştirilirse, Bayi Kodu alanını temizle
        if (name === 'location' && value === 'Özel Adres') {
            setLocalFormData(prev => ({
                ...prev,
                [name]: value,
                code: '' // Bayi Kodu alanını temizle
            }));
        } else {
            setLocalFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: undefined
            }));
        }
    };

    const handleSubmit = useCallback(async () => {
        if (!validateForm()) {
            toast.error(t("fill_required_fields"));
            return;
        }
        setIsSubmitting(true);
        try {
            const url = type === "create" ? "/shippingLocation/create" : "/shippingLocation/update";
            const userId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));

            // Convert form data to a plain object
            const plainObject = {};
            Object.keys(localFormData).forEach(key => {
                const value = localFormData[key];
                // Only include primitive values and arrays
                if (
                    typeof value === 'string' ||
                    typeof value === 'number' ||
                    typeof value === 'boolean' ||
                    Array.isArray(value)
                ) {
                    plainObject[key] = value === "Özel Adres" ? "ÖZEL_ADRES" : value; // Normalize Özel Adres
                }
            });

            const submitData = {
                ...plainObject,
                update_user_id: userId,
                create_user_id: userId
            };
            if (type !== "update") {
                submitData.is_active = true;
            }


            await api.post(url, submitData);
            await fetchData();
            toast.success(t(type === "create" ? "record_created" : "record_updated"));
            onHiding();
        } catch (error) {
            console.error("Error submitting form:", error.message);
            toast.error(t("error_occurred") + ": " + error.message);
        } finally {
            setIsSubmitting(false);
        }
        // eslint-disable-next-line
    }, [localFormData, type, fetchData, onHiding, t]);

    const formatAddress = useCallback((item) => {
        if (!item) return '';
        return `${item.neighborhood}|${item.street}|${item.address}|${item.building_no}|${item.district_name}|${item.city_name}`;
    }, []);

    const renderSelectBox = (name, options = {}) => (
        <FormGroup>
            {renderLabel(name, options.label)}
            <SelectBox
                searchEnabled={true}
                disabled={localFormData.location === 'Özel Adres' && name === 'brand_id'}
                value={localFormData[name]}
                onValueChanged={handleInputChange(name)}
                stylingMode="filled"
                className={errors[name] ? 'border-danger' : ''}
                {...options}
            />
            {renderError(name)}
        </FormGroup>
    );
    const renderLabel = (name, label) => {
        const isRequired = REQUIRED_FIELDS[name];
        if (name === 'brand_id' && localFormData.location === 'Özel Adres') {
            return <Label>{label || REQUIRED_FIELDS[name] || t(name)}</Label>;
        }
        return (
            <Label>
                {label || REQUIRED_FIELDS[name] || t(name)}
                {isRequired && <span className="text-danger">*</span>}
            </Label>
        );
    };

    const renderError = (name) => {
        return errors[name] && (
            <div className="text-danger small mt-1">{errors[name]}</div>
        );
    };

    const renderInput = (name, options = {}) => {
        return (
            <FormGroup>
                {options.label !== false ? renderLabel(name, options.label) : ""}
                <Input
                    type={options.type || "text"}
                    placeholder={options.placeholder}
                    value={localFormData[name] || ''}
                    onChange={handleInputChange(name, options.type)}
                    invalid={!!errors[name]}
                    {...options}
                />
                {renderError(name)}
            </FormGroup>
        )
    };

    const renderTextBox = (name, options = {}) => (
        <FormGroup>
            {renderLabel(name, options.label)}
            <TextBox
                value={localFormData[name] || ''}
                onValueChanged={handleInputChange(name)}
                stylingMode="filled"
                className={errors[name] ? 'border-danger' : ''}
                {...options}
            />
            {renderError(name)}
        </FormGroup>
    );


    return (
        <Modal
            isOpen={visible}
            // toggle={onHiding}
            style={{ maxWidth: "75%", width: "75vw" }}
            dragEnabled
            closeOnOutsideClick
            showTitle
            title={t("dealer_form")}
            width="auto"
            maxHeight="90vh"
            height="auto">
            <ModalHeader toggle={onHiding}>
                Sevkiyat Yerleri
            </ModalHeader>
            <ModalBody style={{ maxHeight: "calc(90vh - 150px)", overflowY: "auto" }}>
                <Row>
                    <Col md={6}>
                        {renderSelectBox("location", {
                            dataSource: ["Türkiye Liman", "Bayi", "Gemi", "Depo", "Özel Adres"]
                        })}

                        {/* Bayi Kodu (zorunlu) ve RRDI Code (opsiyonel) yan yana */}
                        <FormGroup>
                            {localFormData.location === 'Özel Adres' ? (
                                <Label>
                                    Bayi Kodu <span className="text-muted">(otomatik oluşturulacak)</span>
                                </Label>
                            ) : (
                                renderLabel("code", "Bayi Kodu")
                            )}
                            <Row>
                                <Col md={6}>
                                    <TextBox
                                        value={localFormData.code || ''}
                                        onValueChanged={handleInputChange("code")}
                                        stylingMode="filled"
                                        placeholder={localFormData.location === 'Özel Adres' ? "Bayi Kodu (otomatik oluşturulacak)" : "Bayi Kodu (zorunlu)"}
                                        className={errors.code ? 'border-danger' : ''}
                                        disabled={type === "update" || localFormData.location === 'Özel Adres'}
                                    />
                                    {renderError("code")}
                                </Col>
                                <Col md={6}>
                                    <TextBox
                                        value={localFormData.dealer_code || ''}
                                        onValueChanged={handleInputChange("dealer_code")}
                                        stylingMode="filled"
                                        placeholder="RRDI Code (opsiyonel)"
                                    //  isValid={(localFormData.dealer_code === null || localFormData.dealer_code === "" || localFormData.dealer_code === undefined) ? true : localFormData.dealer_code && localFormData.dealer_code.length === 9}
                                    />

                                </Col>
                            </Row>
                        </FormGroup>

                        {renderInput("company_title")}

                        {renderInput("group_company_title")}

                        {renderSelectBox("brand_id", {
                            dataSource: brand,
                            displayExpr: "brand_name",
                            valueExpr: "id"
                        })}

                        {renderInput("address_definition", {
                            type: "textarea"
                        })}

                        <FormGroup>
                            {renderLabel("latitude", t("coordinates"))}
                            <Row>
                                <Col md={6}>
                                    <Input
                                        type="number"
                                        placeholder="Latitude"
                                        value={localFormData.latitude || ''}
                                        onChange={handleInputChange("latitude", "number")}
                                        invalid={!!errors.latitude}
                                    />
                                    {renderError("latitude")}
                                </Col>
                                <Col md={6}>
                                    <Input
                                        type="number"
                                        placeholder="Longitude"
                                        value={localFormData.longitude || ''}
                                        onChange={handleInputChange("longitude", "number")}
                                        invalid={!!errors.longitude}
                                    />
                                    {renderError("longitude")}
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            {renderLabel("phone1", t("phone"))}
                            <Row>
                                <Col md={6}>
                                    <TextBox
                                        value={localFormData.phone1 ? (localFormData.phone1).replaceAll(" ", "") : ''}
                                        mask="(000) 000 00 00"
                                        maskRules={{ "0": /[0-9]/ }}
                                        onValueChanged={handleInputChange("phone1")}
                                        stylingMode="filled"
                                        id='phone1'
                                        className={errors.phone1 ? 'border-danger' : ''}
                                        buttons={[{
                                            name: "phoneIcon",
                                            location: "before",
                                            options: {
                                                icon: "tel",
                                                cssClass: "custom-phone-icon"
                                            }
                                        }]}
                                    />
                                    {renderError("phone1")}
                                </Col>
                                <Col md={6}>
                                    <TextBox
                                        value={localFormData.phone2 || ''}
                                        mask="(000) 000 00 00"
                                        maskRules={{ "0": /[0-9]/ }}
                                        id='phone2'
                                        onValueChanged={handleInputChange("phone2")}
                                        buttons={[{
                                            name: "phoneIcon",
                                            location: "before",
                                            options: {
                                                icon: "tel",
                                                cssClass: "custom-phone-icon"
                                            }
                                        }]}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>

                        {renderInput("distance", { type: "number" })}
                    </Col>

                    <Col md={6}>
                        {renderSelectBox("group_region_id", {
                            dataSource: regions,
                            displayExpr: "name",
                            valueExpr: "id"
                        })}

                        {renderInput("excel_data", {
                            label: t("excel_data"),
                        })}

                        <FormGroup>
                            {/* <Label>Aladin Kodu/Adı</Label> */}
                            {renderLabel("aladin_code", t("aladin_code_name"))}
                            <Row>
                                <Col md={4}>
                                    {renderInput("aladin_code", {
                                        placeholder: "Aladin Kodu",
                                        label: false
                                    })}
                                </Col>
                                <Col md={8}>
                                    {renderInput("aladin_name", {
                                        placeholder: "Aladin Adı",
                                        label: false
                                    })}
                                </Col>
                            </Row>
                        </FormGroup>

                        {renderSelectBox("standard_address_id", {
                            dataSource: adress,
                            displayExpr: formatAddress,
                            valueExpr: "id"
                        })}

                        <FormGroup>
                            {renderLabel("tax_office", t("tax_info"))}
                            <Row>
                                <Col md={6}>
                                    <Input
                                        type="text"
                                        placeholder="Vergi Dairesi"
                                        value={localFormData.tax_office || ''}
                                        onChange={handleInputChange("tax_office")}
                                        invalid={!!errors.tax_office}
                                    />
                                    {renderError("tax_office")}
                                </Col>
                                <Col md={6}>
                                    <Input
                                        type="text"
                                        placeholder="Vergi No"
                                        value={localFormData.tax_number || ''}
                                        onChange={handleInputChange("tax_number")}
                                        invalid={!!errors.tax_number}
                                    />
                                    {renderError("tax_number")}
                                </Col>
                            </Row>
                        </FormGroup>

                        {renderInput("authorized_info", {
                            type: "textarea",
                            placeholder: "Yetkili Bilgileri Giriniz",
                            label: t("authorized_info")
                        })}

                        {renderInput("email", {
                            type: "textarea",
                            label: t("email")
                        })}

                        {renderInput("special_notes", {
                            type: "textarea",
                            label: t("special_notes")
                        })}

                        <FormGroup>
                            <Row>
                                <Col md={4}>
                                    <Label>
                                        {t("is_active")}
                                    </Label> &emsp;
                                    <Switch
                                        width={60}
                                        switchedOffText={t("Hayır")}
                                        switchedOnText={t("Evet")}
                                        value={localFormData.is_active}
                                        onValueChanged={handleInputChange("is_active")}
                                    />
                                </Col>
                                <Col md={7} className='d-flex align-items-center'>
                                    {/* <Label>
                                    {t("is_warehouse")}
                                </Label> &emsp;
                                <Switch
                                    style={{ visible: "hidden" }}
                                    width={60}
                                    switchedOffText={t("Hayır")}
                                    switchedOnText={t("Evet")}
                                    value={localFormData.is_warehouse}
                                    onValueChanged={handleInputChange("is_warehouse")}
                                /> */}
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className="mt-4 d-flex gap-2">
                    <Button
                        onClick={handleSubmit}
                        type="default"
                        className='mr-2 btn'
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? t("save") : t("save")}
                    </Button>
                    <Button
                        onClick={onHiding}
                        type="danger"
                        className='btn btn-danger'
                        disabled={isSubmitting}
                    >
                        {t("cancel")}
                    </Button>
                </div>
            </ModalFooter>

        </Modal>
    );
};

export default React.memo(BayiFormPopup);